module.exports = __webpack_public_path__ + "img/category-detail-icon4.cf8536d4.svg";